import { Cart } from "@insite/client-framework/Services/CartService";
import { getUnitNetPrice } from "@insite/client-framework/Services/Helpers/ProductPriceService";
import { hasRestrictedCartLines, isCartEmpty } from "@insite/client-framework/Store/Data/Carts/CartsSelector";

export const customIsCartCheckoutDisabled = (cart: Cart | undefined) =>
    cart && ( isCartEmpty(cart) || hasRestrictedCartLines(cart));

export const customHasOnlyQuoteRequiredProducts = (cart: Cart | undefined) =>
    cart?.cartLines?.every(
        cartLine =>
            cartLine.quoteRequired ||
            (!cartLine.quoteRequired &&
                !cartLine.allowZeroPricing &&
                cartLine.pricing &&
                getUnitNetPrice(cartLine.pricing, 1).price === 0),
    );

export const customHasQuoteRequiredProducts = (cart: Cart | undefined) =>
    cart?.cartLines?.some(
        cartLine =>
            cartLine.quoteRequired ||
            (!cartLine.quoteRequired &&
                !cartLine.allowZeroPricing &&
                cartLine.pricing &&
                getUnitNetPrice(cartLine.pricing, 1).price === 0),
    );
